import { IState } from '../../store';

export function selectTrackingUser(state: IState) {
  return state.tracking.user;
}
